import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e60afbe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60afbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e60afbe')) {
      api.createRecord('4e60afbe', component.options)
    } else {
      api.reload('4e60afbe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e60afbe&scoped=true&", function () {
      api.rerender('4e60afbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCompany/index.vue"
export default component.exports